import styled from "styled-components";

const Trusted = () => {
  return (
    <Wrapper>
      <div className="container">
        <p>We have 10K+ Trusted Trade Partners</p>
        <div className="slider">
          <div className="carousel">
            <div className="wrap">
              <img src="/images/Brand/AAET.png" alt="Company 1" />
              <img src="/images/Brand/AAK.png" alt="Company 2" />
              <img src="/images/Brand/SST.png" alt="Company 3" />
              <img src="/images/Brand/SIFON.png" alt="Company 4" />
              <img src="/images/Brand/GEM1.png" alt="Company 5" />
              <img src="/images/Brand/millennunim.png" alt="Company 6" />
              <img src="/images/Brand/MAXIS.png" alt="Company 1" />
              <img src="/images/Brand/AAET.png" alt="Company 1" />
              <img src="/images/Brand/AAK1.png" alt="Company 5" />
              <img src="/images/Brand/millennum.png" alt="Company 6" />
              {/* repeat logos so animation looks continuous */}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`

  text-align: center;
  padding: 3rem 0;

 P {font-size: 25px;
  font-weight: bold;
  }

  .slider {
    margin: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius:20px;
    background-color: #e8f3f3;
    box-shadow:1px 1px 2px 2px  #97a1a2;
   
  }

  .carousel {
    overflow: hidden;
    width: 90%;
  }

  .wrap {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 20%;
    gap: 1rem;
    align-items: center;
    animation: slide 20s linear infinite;
    
  }

  .wrap img {
    width: 8rem;
    height: 8rem;
    object-fit: contain;
  }

  @keyframes slide {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-100%);
    }
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .wrap {
      grid-auto-columns: 50%;
    }

   P{font-size: 15px;
 }
   .wrap {
    grid-auto-columns: 30%;
    
  }
  .wrap img {
    width: 6rem;
    height: 6rem;
  }
  }
`;

export default Trusted;